export default __webpack_public_path__ + "static/media/tire.5eb73621.png";